import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ExternalLink, Sparkles } from "lucide-react";
import api from "@/lib/api";
import { resolveAssetUrl } from "@/lib/url";

export const AdBanner = () => {
    const [s, setS] = useState(null);

    useEffect(() => {
        api.get("/settings").then((r) => setS(r.data || {})).catch(() => setS({}));
    }, []);

    if (!s || !s.ad_enabled || (!s.ad_title && !s.ad_subtitle && !s.ad_image_url)) return null;

    const inner = (
        <>
            {s.ad_image_url && (
                <div className="relative md:w-72 lg:w-96 aspect-[16/10] md:aspect-auto md:self-stretch shrink-0 overflow-hidden rounded-2xl">
                    <img src={resolveAssetUrl(s.ad_image_url)} alt={s.ad_title || "Reklama"} className="w-full h-full object-cover" />
                </div>
            )}
            <div className="flex-1 min-w-0">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#D4A537]/20 text-[#D4A537] text-[10px] font-semibold uppercase tracking-[0.2em] mb-3">
                    <Sparkles size={11} /> {s.ad_badge || "Reklama"}
                </div>
                {s.ad_title && <h3 className="font-serif text-2xl md:text-3xl text-white mb-2 leading-tight">{s.ad_title}</h3>}
                {s.ad_subtitle && <p className="text-white/75 text-sm md:text-base leading-relaxed mb-4">{s.ad_subtitle}</p>}
                {s.ad_link && (
                    <span className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-[#D4A537] text-[#092E22] font-semibold text-sm hover:bg-[#E5B848] transition-all group-hover:-translate-y-0.5">
                        {s.ad_cta || "Dowiedz się więcej"} <ExternalLink size={14} />
                    </span>
                )}
            </div>
        </>
    );

    const wrapperClass = "group flex flex-col md:flex-row items-stretch gap-6 p-6 md:p-8 rounded-3xl bg-gradient-to-br from-[#092E22] to-[#0D4F3C] border border-[#D4A537]/20 transition-all duration-300 hover:shadow-2xl";

    return (
        <section data-testid="ad-section" className="py-12 bg-[#FDFDFD]">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    {s.ad_link ? (
                        <a href={s.ad_link} target="_blank" rel="noopener noreferrer" className={wrapperClass} data-testid="ad-banner-link">
                            {inner}
                        </a>
                    ) : (
                        <div className={wrapperClass} data-testid="ad-banner">{inner}</div>
                    )}
                </motion.div>
            </div>
        </section>
    );
};

export default AdBanner;
